import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Produtos', href: '#produtos' },
  { label: 'Sobre Nós', href: '#sobre' },
  { label: 'Benefícios', href: '#beneficios' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Contato', href: '#contato' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.getElementById(href.replace('#', ''));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-[#C8E8E8]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNav('#home'); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/61892072331720d5ae52870a50f3ccd8/20cef7de92f0add5ce8c53134a30c56c.png"
            alt="Logo"
            className="h-24 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-[#1A1A1A] hover:text-[#0F7C7A]'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#produtos"
          onClick={(e) => { e.preventDefault(); handleNav('#produtos'); }}
          className="hidden lg:inline-flex items-center gap-2 bg-[#0F7C7A] hover:bg-[#0A5F5C] text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-shopping-bag-line" />
          Comprar Agora
        </a>

        {/* Mobile Menu Toggle */}
        <button
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors ${
            scrolled ? 'text-[#2C2C2C]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-[#C8E8E8] px-6 py-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className="block py-3 text-[#1A1A1A] text-sm font-medium border-b border-[#DFF0F0] last:border-none cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => handleNav('#produtos')}
            className="mt-4 w-full bg-[#0F7C7A] text-white text-sm font-semibold py-3 rounded-full cursor-pointer whitespace-nowrap"
          >
            Comprar Agora
          </button>
        </div>
      )}
    </header>
  );
}
